// import React, { useState } from "react";
// import { CommonInput, CommonLoader } from "..";
// import { FaMagnifyingGlass } from "react-icons/fa6";

// const CommonMovieSearch = ({ onMovieSelect, value, onChange }) => {
//   const [error, setError] = useState(null);
//   const [isLoading,setIsLoading]= useState(false)

//   const fetchMovieData = async () => {
//     setIsLoading(true)
//     const apiKey = process.env.REACT_APP_OMDB_API_KEY;
//     const url = `https://www.omdbapi.com/?apikey=${apiKey}&t=${encodeURIComponent(value)}&type=movie`;

//     try {
//       const response = await fetch(url);
//       const data = await response.json();

//       if (data.Response === "True") {
//         setError(null);
//         onMovieSelect(data);
//       } else {
//         setError(data.Error || "Movie not found");
//       }
//     } catch (err) {
//       setError("Something went wrong");
//     }
//     setIsLoading(false)
//   };

//   return (
//     <div className="__movieSearch">
//       <CommonInput
//         label="Content Title"
//         placeholder="Search Title"
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//       />
//       <button onClick={fetchMovieData}>{isLoading? <CommonLoader loaderClass="movie_load" />:<FaMagnifyingGlass />}</button>

//       {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
//     </div>
//   );
// };

// export default CommonMovieSearch;

import React, { useState, useEffect } from "react";
import { CommonInput, CommonLoader } from "..";
import { FaMagnifyingGlass } from "react-icons/fa6";

const CommonMovieSearch = ({ onMovieSelect, value, onChange }) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const apiKey = process.env.REACT_APP_OMDB_API_KEY;

  const fetchSuggestions = async (query) => {
    if (!query) return setSuggestions([]);

    setIsLoading(true);
    try {
      const url = `https://www.omdbapi.com/?apikey=${apiKey}&s=${encodeURIComponent(
        query
      )}&type=movie`;
      const response = await fetch(url);
      const data = await response.json();

      if (data.Response === "True") {
        setSuggestions(data.Search);
        setError(null);
      } else {
        setSuggestions([]);
        setError(data.Error);
      }
    } catch (err) {
      setSuggestions([]);
      setError("Something went wrong");
    }
    setIsLoading(false);
  };

  const handleInputChange = (val) => {
    onChange(val);
    fetchSuggestions(val);
  };

  const handleSelectSuggestion = (movie) => {
    onChange(movie.Title);
    setSuggestions([]);
    onMovieSelect(movie);
  };

  return (
    <div
      className="__movieSearch"
      style={{
        position: "relative",
        ...(error ? { marginBottom: "1rem" } : {}),
      }}
    >
      <CommonInput
        label="Content Title"
        placeholder="Search Title"
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
      />
      <button onClick={() => fetchSuggestions(value)}>
        {isLoading ? (
          <CommonLoader loaderClass="movie_load" />
        ) : (
          <FaMagnifyingGlass />
        )}
      </button>

      {suggestions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ccc",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
            listStyle: "none",
            padding: "0.5rem",
          }}
        >
          {suggestions.map((movie) => (
            <li
              key={movie.imdbID}
              onClick={() => handleSelectSuggestion(movie)}
              style={{
                padding: "4px 8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
            >
              {movie.Title} ({movie.Year})
            </li>
          ))}
        </ul>
      )}

      {error && (
        <p
          style={{
            color: "red",
            margin: "0",
            position: "absolute",
            left: "0px",
            bottom: "-20px",
            fontSize: "12px",
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default CommonMovieSearch;
